import React from 'react';
import WalletPanel from '../components/profile/WalletPanel';
import { PageShell } from '../components/shared/PageShell';

const ProfilePage: React.FC = () => {
  return (
    <PageShell>
      <WalletPanel />
    </PageShell>
  );
};

export default ProfilePage;

